import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        display: block;
        height: 100%;
    }

    .nav-item {
        display: flex;
        gap: var(--sgdf-spacing-x-small);
    }
`;
//# sourceMappingURL=entities-search.styles.js.map